import { action, observable } from "mobx";
import { BaseEditViewStore } from "core/stores";
import { ModalParams } from 'core/models';
import { NikoPatientDetailService } from "application/niko-patient/services";
import { NikoPatientStatusModalForm } from 'application/niko-patient/forms';
import { getErrorMessage } from "core/utils";
class NikoPatientStatusModalStore extends BaseEditViewStore {
	@observable accessor disabled = false;
	constructor(rootStore, componentProps) {
        const nikoPatientDetail = componentProps.modalParams.data.nikoPatientDetail;
        const status = componentProps.modalParams.data.status;
        const isDateVisible = status == 'Discharged' || status == 'Expired';
        const nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        const pageName = componentProps.modalParams.data.pageName;
        const tabName = componentProps.modalParams.data.tabName;
        super(rootStore, {
			name: 'niko-patient-status-modal',
			Form: NikoPatientStatusModalForm,
			id: nikoPatientDetail.id,
			actions: () => {
				return {
					get: async () => {
						return { id: nikoPatientDetail.id, status: status, inactiveDate: null };
					},
					update: async (resource) => {
						try {
							this.disabled = true;
							this.form.setFieldsDisabled(true);
							resource.pageName = pageName;
							resource.tabName = tabName;
							const response = await nikoPatientDetailService.updatePatientStatus(resource);
							await componentProps.modalParams.data.getNikoPatient();
							this.modalParams.close();
							// ISG-871: surface drainage bag / leg bag validation warnings from a patient activation (status -> Active).
							const validationMessages = response && response.data && response.data.customValues && response.data.customValues.validationMessages;
							if (validationMessages && validationMessages.length) {
								validationMessages.forEach((message) => this.rootStore.notificationStore.warning(message));
							}
						}
						catch (err) {
							this.disabled = false;
							this.form.setFieldsDisabled(false);
							return this.onUpdateError(err);
						}
					}
				}
			},
			FormClass: NikoPatientStatusModalForm
		});

        this.rootStore = rootStore;
        this.status = status;
        this.modalParams = componentProps.modalParams;
        this.isDateVisible = isDateVisible;
        this.additionalMessage = this.modalParams.data.additionalMessage;
        this.skipValidation = this.modalParams.data.skipValidation;
        this.nikoPatientDetail = nikoPatientDetail;

        this.inactiveDateConfirmationModal = new ModalParams({ onClose: null });
        this.inactiveDateConfirmationModal.yesLabel = 'MODAL.YES_PROCESS';
        this.inactiveDateConfirmationModal.onCancel = () => { this.inactiveDateConfirmationModal.close(); };
        this.inactiveDateConfirmationModal.noLabel = 'MODAL.NO_CANCEL';
        this.inactiveDateConfirmationModal.swapButtons = true;
    }

	onUpdateError(err) {
		this.rootStore.notificationStore.error(getErrorMessage(err, 'Error occurred while trying to update a Niko Patient status.'));
	}

	@action.bound
	async updateResource(resource) {
		if (this.additionalMessage && !this.skipValidation) {
			if (this.nikoPatientDetail.eligibilityStatus == null) {
				this.rootStore.notificationStore.error('Eligibility status must be selected prior to activation.');
				return;
			}
			if (this.nikoPatientDetail.eligibilityStatus.name === 'Eligible' && this.nikoPatientDetail.primaryActive.insuranceId.current == null) {
				this.rootStore.notificationStore.error('Primary Insurance must be added prior to activation.');
				return;
			}
		}

		if (this.isDateVisible) {
			if (resource.inactiveDate == null) {
				this.inactiveDateConfirmationModal.onConfirm = async () => { this.inactiveDateConfirmationModal.close(); await this.actions.update(resource); };
				this.inactiveDateConfirmationModal.open({
					message: 'NIKO_PATIENT.NIKO_PATIENT_STATUS_MODAL.INACTIVE_DATE_WARNING_MESSAGE'
				});
			}
			else if (resource.inactiveDate < new Date(1901, 0, 1)) {
				this.rootStore.notificationStore.error('Minimum date is 1/1/1901.');
			}
			else {
				await this.actions.update(resource);
			}
		}
		else {
			await this.actions.update(resource);
		}
	}
}

export default NikoPatientStatusModalStore;